exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-outage-no-selection{letter-spacing:.1rem;opacity:.8}.admin-outage-link{color:#ffaa0d !important;font-weight:bold;margin-left:0.5rem}.admin-outage-variable-layout{align-self:center;margin-left:10px}\n", ""]);

// exports
